/**
 *
 *
 * @fileoverview Search page context
 * this file saved as a reference for now
 * @todo TODO: remove this file after RW-116 is somewhat stable or in production
 *
 *
 */

export * from "./searchPage.context";

// import React, { useState, PropsWithChildren, useEffect } from "react";

// import { useRouter } from "next/router";

// import { ObjectKeys, removeKeysWithFalsyValues } from "@/utils/object.utils";

// import { searchSliderMinMaxValues } from "../constants";
// import { LadiesSearchReqParams, convertFormValuesToParams } from "../helpers";
// import {
//   useLadiesSearch,
//   useDefaultFormValuesFromSearchParams,
//   useLadiesSearchPaginationOptions,
// } from "../hooks";

// const SearchContext = React.createContext<null | ReturnType<
//   typeof useCreateSearchContext
// >>(null);

// const useCreateSearchContext = () => {
//   const [stateParams, setStateParams] = useState<LadiesSearchReqParams | null>(
//     null,
//   );

//   // const { data: ladies } = useLadiesSearch(stateParams);
//   const ladies = undefined;
//   // const { data: paginationOptions } =
//   //   useLadiesSearchPaginationOptions(stateParams);
//   const paginationOptions = undefined;

//   const router = useRouter();

//   const mixPageToParams = (page: number) => {
//     setStateParams((params) => ({ ...params, page }));
//     pushToRouter({ page }, "append");
//   };

//   const pushToRouter = (objValue: LadiesSearchReqParams, append?: "append") => {
//     if (append === "append") {
//       const firstKey = ObjectKeys(objValue)[0];
//       router.query[firstKey] = objValue[firstKey] as string;

//       router.push(
//         {
//           pathname: "/search",
//           query: router.query,
//         },
//         undefined,
//         { shallow: true },
//       );
//       return;
//     }

//     router.push(
//       {
//         pathname: "/search",
//         query: removeKeysWithFalsyValues(objValue),
//       },
//       undefined,
//       { shallow: true },
//     );
//   };

//   const setParams = (formValues: LadiesSearchReqParams) => {
//     const params = convertFormValuesToParams(
//       formValues,
//       searchSliderMinMaxValues,
//     );

//     pushToRouter(formValues);
//     setStateParams(params);
//   };
//   const defaultFormValues = useDefaultFormValuesFromSearchParams();

//   useEffect(() => {
//     if (!!defaultFormValues) {
//       setStateParams(
//         convertFormValuesToParams(defaultFormValues, searchSliderMinMaxValues),
//       );
//     }
//   }, [defaultFormValues]);

//   return {
//     params: stateParams,
//     setParams,
//     ladies,
//     paginationOptions: { paginationOptions },
//     defaultFormValues,
//     pushToRouter,
//     mixPageToParams,
//     paramsPage: stateParams?.page,
//   };
// };

// export const SearchContextProvider: React.FC<PropsWithChildren> = ({
//   children,
// }) => {
//   const context = useCreateSearchContext();

//   return (
//     <SearchContext.Provider value={context}>{children}</SearchContext.Provider>
//   );
// };

// export const useSearchContext = () => {
//   const searchContext = React.useContext(SearchContext);
//   if (!searchContext) throw new Error("Use app context within provider!");
//   return searchContext;
// };
